import React from 'react';

function FailureBody({ t }) {
  return (
    <div className="cancellation-fail-transaction kupos-card content-container light-text font12">
      <div className="font13">
        {t('RESULTS_PAGE.WHAT_WRONG.NORMAL')}
        <span className="bold-text"> {t('RESULTS_PAGE.WHAT_WRONG.BOLD')}</span>
      </div>

      <div className=" display-flex icon-text-section">
        <img src="/images/icons/icon-countdown.png" />
        <span>{t('RESULTS_PAGE.TIME_REJECT')}</span>
      </div>

      <div className=" display-flex icon-text-section">
        <img src="/images/icon_card.png" />
        <span>{t('RESULTS_PAGE.BANK_REJECT')}</span>
      </div>

      <div className=" display-flex icon-text-section">
        <img src="/images/icon_wifi.png" />
        <span>{t('RESULTS_PAGE.INTERNET_REJECT')}</span>
      </div>

      <div className="font13 title2">
        <span className="bold-text">{t('RESULTS_PAGE.WHAT_CAN_YOU_DO')}</span>
      </div>

      <div className="my-3">{t('RESULTS_PAGE.BEST_SERVICE')}</div>

      {/* <div className=" display-flex icon-text-section">
               <img src="/images/icon_whatsapp.png" />
               <span>
                 Puede que hayas tenido un problema o baja conexión a Internet haciendo que la
                 transacción fallara.
               </span>
             </div> */}
    </div>
  );
}

export default FailureBody;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/BookingSuccess/components/FailureBody.js